import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import helpersComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import helperComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import TaglineHelper from "utilities/helpers/helpers-tagline/1.0.0/js/tagline-helper";
import MenuNav from "modules/global/global-nav-module/10.0.6/js/menu-nav";
import spartaTemplates from "modules/global/global-nav-module/10.0.6/js/templates";
import "css!modules/global/global-nav-module/10.0.6/css/global-nav-module.scss.css";
import "css!modules/global/global-nav-module/10.0.6/css/search-stub-overwrite.scss.css";
import "css!modules/global/global-nav-module/10.0.6/css/menu-nav.scss.css";
/**
 * @file        global-nav-module.js
 * @description A header for sites that need a header with navigation and search.
 * @author      Jesse Dotson (ZKPISBX), Jesse Price (ZKFF3D3), Sunny Singh (ZKTUUYV)
 * @copyright   © 2018 Bank of America Corporation. All rights reserved.
 */

/* global Module MenuNav */

const selectors = {
  header: '.header',
  menuButton: '.js-menu-button',
};

const cssModifiers = {
  open: 'header--open',
};

const events = {
  menuButtonClicked: 'GLOBAL_NAV_MODULE_MENU_BUTTON.clicked',
  navigationCollapsed: 'MENU_NAV_MODULE_NAVIGATION.collapsed',
};

/**
 * Default and Parent Class for Global Navigation
 * @export
 * @class GlobalNavModuleJS
 * @extends {Module}
 */
export default class GlobalNavModuleJS extends Module {
  /**
   * Add event listeners and call initialization functions
   * @returns {undefined}
   */
  init() {
    const headerModuleElement = this.settings.target;
    const menuButtonElement = headerModuleElement.querySelector(selectors.menuButton);
    if (menuButtonElement) {
      menuButtonElement.addEventListener('click', this.menuButtonClick.bind(this));
      MenuNav.init(this.settings.target);
    }
  }

  /**
   * Event Handling for click menu button
   * Fires an event for child module to work from
   * @param {object} event - event passed from listener
   * @returns {undefined}
   */
  menuButtonClick(event) {
    const header = this.settings.target.querySelector(selectors.header);

    // toggle the 'open' class (this will trigger arrow rotation animation)
    header.classList.toggle(cssModifiers.open);

    this.Events.pub(events.menuButtonClicked);

    GlobalNavModuleJS.setAriaExpanded({
      referenceElem: header,
      targetElem: event.currentTarget,
      invert: false,
    });
  }

  /**
  * @param  {object} Elements - Collection of reference and target `Elements`.
  * Calls `GlobalNavModuleJS.syncAttrClass` with some properties already set
  *
  * @param  {HTMLElement} Elements.referenceElem - Element to check for 'collapsed' class on
  * @param  {HTMLElement} Elements.targetElem - Element to set the 'aria-expanded' attribute on
  * @returns {void}
  */
  static setAriaExpanded({ referenceElem, targetElem, invert }) {
    GlobalNavModuleJS.syncAttrClass({
      referenceElem,
      targetElem,
      attr: 'aria-expanded',
      className: cssModifiers.open,
      invert,
    });
  }

  /**
   * Check if `className` is present on `referenceElem` and set `attr` to `true`
   * if present or `false` if absent
   * @param {object} args - Configuration object
   * @param {HTMLElement} args.referenceElem - Element to check for 'className' class on
   * @param {HTMLElement} args.targetElem - Element to set the attribute on
   * @param {string} args.attr - Attribute to change
   * @param {string} args.className - Name of the class check for
   * @param {boolean} args.invert - `attr` should be false if `className` is present
   *
   * @returns {undefined}
   */
  static syncAttrClass({
    referenceElem,
    targetElem,
    attr,
    className,
    invert,
  }) {
    let attrVal = referenceElem.classList.contains(className);

    if (invert) {
      attrVal = !attrVal;
    }

    targetElem.setAttribute(attr, attrVal);
  }
}
